import(/* webpackMode: "eager" */ "/opt/stpi-client/src/app/(index)/related-links/page.tsx");
